export const cargos = [
    'Auxiliar',
    'Executivo',
    'Vendedor',
    'Analista',
    'Consultor',
    'Coordenador',
    'Supervisor',
    'Gerente',
    'Diretor'
]